import { AdapterFactory } from '../AdapterFactory';

export const vendorService = AdapterFactory.getVendorAdapter();
